import { AuthenticationApiActions, AuthenticationActions } from '@app/auth/actions';
import { Token } from '@app/auth/models/token';
import { User } from '@app/users/models/user';

export interface State {
  user: User | null;
  tokens: Token | null;
}

export const initialState: State = {
  user: null,
  tokens: null
};

export function reducer(
  state = initialState,
  action: AuthenticationApiActions.AuthenticationApiActionsUnion | AuthenticationActions.AuthenticationActionsUnion
): State {
  switch (action.type) {
    case AuthenticationApiActions.AuthenticationApiActionTypes.LoginSuccess: {
      return { ...state, tokens: action.payload.tokens };
    }
    case AuthenticationActions.AuthenticationActionTypes.Logout: {
      localStorage.clear();
      return initialState;
    }
    case AuthenticationApiActions.AuthenticationApiActionTypes.RetrieveUserSuccess: {
      return { ...state, user: action.payload.user };
    }
    default: {
      return state;
    }
  }
}

export const getUser = (state: State) => state.user;

export const getTokens = (state: State) => state.tokens;
